import { render, staticRenderFns } from "./MigrationHistory.vue?vue&type=template&id=27d83073&"
import script from "./MigrationHistory.vue?vue&type=script&lang=ts&"
export * from "./MigrationHistory.vue?vue&type=script&lang=ts&"
import style0 from "./MigrationHistory.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports